import { createLocalizationStoreInstance, LocalizationStore } from './System/LocalizationStore';
import { authenticationStore, AuthenticationStore } from './AuthenticationStore';
import { createRemoteSettingsStoreInstance, RemoteSettingsStore } from '../Services/Firebase/RemoteSettingsStore';
import { createAnalyticsStoreInstance, AnalyticsStore } from './Firebase/AnalyticsStore';
import { supportStore, SupportStore } from './SupportStore';
import { createGymCustomerStoreInstance, GymCustomerStore } from './GymCustomerStore';
import { coachSubscriptionStore, CoachSubscriptionStore } from './CoachSubscriptionStore';
import { createEngagementStoreInstance, EngagementStore } from './EngagementStore';
import { createWorkoutViewStoreInstance, WorkoutViewStore } from './WorkoutViewStore';
import { createWorkoutRunnerInstance, WorkoutRunner } from './WorkoutRunner';
import { createWorkoutAnalyticsStoreInstance, WorkoutAnalyticsStore } from './WorkoutAnalyticsStore';

export type RootStore = {
  authentication: AuthenticationStore;
  language: LocalizationStore;
  remoteSettings: RemoteSettingsStore;
  analytics: AnalyticsStore;
  support: SupportStore;
  gymCustomer: GymCustomerStore;
  coachSubscription: CoachSubscriptionStore;
  engagement: EngagementStore;
  workoutRunner: WorkoutRunner;
  workoutViewStore: WorkoutViewStore;
  analyticsWorkout: WorkoutAnalyticsStore;
};

export function createRootStore(): RootStore {
  const authentication = authenticationStore;
  const remoteSettings = createRemoteSettingsStoreInstance(authentication);
  const language = createLocalizationStoreInstance(remoteSettings);
  const analytics = createAnalyticsStoreInstance(authentication, language);
  const support = supportStore;
  const gymCustomer = createGymCustomerStoreInstance(authentication, analytics);
  const coachSubscription = coachSubscriptionStore;
  const engagement = createEngagementStoreInstance(gymCustomer, language);
  const workoutRunner = createWorkoutRunnerInstance(authentication, analytics);
  const workoutViewStore = createWorkoutViewStoreInstance(authentication, workoutRunner, language, analytics);
  const analyticsWorkout = createWorkoutAnalyticsStoreInstance(workoutRunner, analytics);

  return {
    authentication,
    language,
    remoteSettings,
    analytics,
    support,
    gymCustomer,
    coachSubscription,
    engagement,
    workoutRunner,
    workoutViewStore,
    analyticsWorkout,
  };
}
